export default __webpack_public_path__ + "static/media/OurFirstPhoto.497e2add.png";